import * as CardCrawl from "@ravalmatic/cardcrawl-engine";
import { GameVars } from "../../GameVars";
import { BoardContainer } from "../board-scene/BoardContainer";

export class HandCursor extends Phaser.GameObjects.Container {

    private hand: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        const from = GameVars.tutorialStepData.from;

        let s: number;

        if (from.tableau === CardCrawl.TableauType.UPPER && from.i === 3) {
            s = -1;
        } else {
            s = 1;
        }

        this.hand = new Phaser.GameObjects.Image(this.scene, -5, -5, "texture_atlas_1", "hand_cursor");
        this.hand.setOrigin(0);
        this.hand = this.hand.setScale(s, GameVars.scaleY);
        this.add(this.hand);

        // DETERMINAR LA POSICIÓN INICIAL
        const p = from.tableau === CardCrawl.TableauType.UPPER ? BoardContainer.currentInstance.upperTableauContainer.getCardPosition(from.i) : BoardContainer.currentInstance.lowerTableauContainer.getCardPosition(from.i);

        this.x = p.x + BoardContainer.currentInstance.x;
        this.y = p.y * GameVars.scaleY + BoardContainer.currentInstance.y;

        if (from.tableau === CardCrawl.TableauType.UPPER) {
            this.x += BoardContainer.currentInstance.upperTableauContainer.x;
            this.y += BoardContainer.currentInstance.upperTableauContainer.y * GameVars.scaleY;
        } else {
            this.x += BoardContainer.currentInstance.lowerTableauContainer.x;
            this.y += BoardContainer.currentInstance.lowerTableauContainer.y * GameVars.scaleY;
        }

        if (GameVars.tutorialStepData.allowedMoves) {

            let to: {tableau: CardCrawl.TableauType, i: number};

            const allowedMoves = GameVars.tutorialStepData.allowedMoves;

            if (allowedMoves.upperTableau.indexOf(true) !== -1) {
                to = {tableau: CardCrawl.TableauType.UPPER, i: allowedMoves.upperTableau.indexOf(true)};
            } else if (allowedMoves.lowerTableau.indexOf(true) !== -1) {
                to = {tableau: CardCrawl.TableauType.LOWER, i: allowedMoves.lowerTableau.indexOf(true)};
            } else {
                to = {tableau: CardCrawl.TableauType.SHOP, i: null};
            }

            let finalX: number;
            let finalY: number;

            if (to.tableau === CardCrawl.TableauType.UPPER) {
                const p = BoardContainer.currentInstance.upperTableauContainer.getCardPosition(to.i);
                finalX = p.x + BoardContainer.currentInstance.x + BoardContainer.currentInstance.upperTableauContainer.x;
                finalY = p.y * GameVars.scaleY + BoardContainer.currentInstance.y + BoardContainer.currentInstance.upperTableauContainer.y;

            } else if (to.tableau === CardCrawl.TableauType.LOWER) {
                const p = BoardContainer.currentInstance.lowerTableauContainer.getCardPosition(to.i);
                finalX = p.x + BoardContainer.currentInstance.x + BoardContainer.currentInstance.lowerTableauContainer.x;
                finalY = p.y * GameVars.scaleY + BoardContainer.currentInstance.y + BoardContainer.currentInstance.lowerTableauContainer.y;
            } else {
                finalX = BoardContainer.currentInstance.x + BoardContainer.currentInstance.chest.x - 15;
                finalY = BoardContainer.currentInstance.y + BoardContainer.currentInstance.chest.y * GameVars.scaleY;
            }

            this.scene.tweens.add({
                targets: this,
                x: finalX,
                y: finalY,
                duration: 2500,
                ease: Phaser.Math.Easing.Cubic.Out,
                repeat: -1,
                loopDelay: 1000
            });

        } else {

            // LA ANIMACION DE PRESS AND HOLD
            this.handPressAndHoldTween();
        }
    }

    private handPressAndHoldTween(): void {

        this.scene?.tweens.add({
            targets: this.hand,
            x: this.hand.x - 5,
            scaleX: .9,
            scaleY: GameVars.scaleY * .9,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 300,
            onComplete: () => {

                if (this.scene) {

                    const pressHoldFX = new Phaser.GameObjects.Sprite(this.scene, this.hand.x + 15, this.hand.y +15 * GameVars.scaleY, "texture_atlas_1", "press_hold_01");
                    pressHoldFX.play("press_card_fx");
                    pressHoldFX.setScale(1.25, 1.25 * GameVars.scaleY);
                    this.addAt(pressHoldFX, 0);
    
                    this.scene?.time.delayedCall(750, () => {
                            
                            this.scene?.tweens.add({
                                targets: this.hand,
                                x: this.hand.x + 5,
                                scaleX: 1,
                                scaleY: GameVars.scaleY,
                                ease: Phaser.Math.Easing.Cubic.Out,
                                duration: 30,
                                onComplete: () => {
                                    this.handPressAndHoldTween();
                                },
                                onCompleteScope: this
                            });
                        }, [], this);
                }
            },
            onCompleteScope: this
        });
    }
}
